import { createContext, useContext } from 'react';
const SuperUserContent = createContext(null);

export const SuperUserProvider = ({ orgID, children }) => {
    return (
        <SuperUserContent.Provider value={{ orgID }}>
            {children}
        </SuperUserContent.Provider>
    );
};

export const useSuperUser = () => useContext(SuperUserContent);
